import React from 'react'
import { useTranslate, useRecordContext } from 'react-admin'
import { Box, Typography, Dialog, DialogContent, Button, DialogActions } from '@mui/material'

function cleanHtml(html) { // eliminar saltos de linea (cuando hay etiquetas vacias)
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const tags = ['li', 'ul', 'p', 'b']; // Agrega las etiquetas que necesites limpiar

  tags.forEach(tag => {
    doc.querySelectorAll(tag).forEach(elem => {
      if (!elem.textContent.trim()) {
        elem.parentNode.removeChild(elem);
      }
    });
  });

  return doc.body.innerHTML; // Devuelve el HTML limpio
}

export const TrainPassesCondition = ({ open, handleClose, data }) => {
  const record = useRecordContext()
  const train_passes = data ? data : record?.passes?.[0]
  const translate = useTranslate()

  const cleanConditions = (conditions) => conditions.map(condition => ({
    ...condition,
    condition: cleanHtml(condition.condition)
  }));

  if (
    train_passes &&
    train_passes?.conditions &&
    Array.isArray(train_passes?.conditions) &&
    train_passes?.conditions.length > 0
  ) {
    const cleanedConditions = cleanConditions(train_passes.conditions);

    return (
      <Dialog open={open} maxWidth='lg' fullWidth={true}>
        <DialogContent>
          <Box style={{ border: '4px solid #F9F9FD', borderRadius: '10px', padding: 10 }}>
            <Typography variant='h6' component='div' textAlign={'center'}>
              {translate('ra.title.condition')}
            </Typography>
            {cleanedConditions.map((elem, key) => {
              return <div key={key} dangerouslySetInnerHTML={{ __html: elem.condition }}></div>
            })}
          </Box>
          <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
            <Button onClick={handleClose} variant='outlined' color='error'>
              {translate('ra.action.close')}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    )
  }
  return null;
}
